import { FC } from 'react';

import DataProvider from 'application/providers/DataProvider';
import { AppModalHostProvider } from '@app/modal';
import { StoreProvider } from '@app/providers';
import AppInitializer from 'application/providers/AppInitializer';
import GTMWrapper from 'application/components/GTMWrapper';
import SupportChat from 'application/components/widgets/SupportChat';

import { MediaQueriesProvider } from '@zvuk-b2b/react-uikit/toolkit/useMedia';

import ApplicationRouter from './Application';

const Main: FC = () => (
  <DataProvider>
    <StoreProvider>
      <AppModalHostProvider>
        <AppInitializer>
          <MediaQueriesProvider>
            <ApplicationRouter />
          </MediaQueriesProvider>
          <SupportChat />
        </AppInitializer>
      </AppModalHostProvider>
    </StoreProvider>
    <GTMWrapper />
  </DataProvider>
);

export default Main;
